//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Actions ------------------------
import * as ActivityActions from './actions';
import { updateUI } from 'store/UI/actions';

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- List books ----------------


//  -- List books ----------------
export const handleInvokeMainbook = (open,pages) => async (dispatch) => {
    await dispatch(ActivityActions.invokeMainBook(open,pages));
}
export const handleRevokeMainbook = () => async (dispatch) => {
    await dispatch(ActivityActions.revokeMainbook());
}

export const handleSentenceInvoke = (open,pages) => async (dispatch) => {
    await dispatch(ActivityActions.invokeSentence(open,pages));
}
export const handleSentenceRevoke = () => async (dispatch) => {
    await dispatch(ActivityActions.revokeSentence());
}

export const handleAiAnswerInvoke = (open, questions) => async (dispatch) => {
    await dispatch(ActivityActions.invokeAiAnswer(open, questions));
}
export const handleAiAnswerRevoke = () => async (dispatch) => {
    await dispatch(ActivityActions.revokeAiAnswer());
}

export const handleMatchMakingInvoke = () => async(dispatch) => {
    await dispatch(ActivityActions.invokeMatchMaking(true));
}
export const handleMatchMakingRevoke = () => async(dispatch) => {
    await dispatch(ActivityActions.revokeMatchMaking(false));
}


export const handleInvokeEbookGalleryView = (open,pages) => async (dispatch) => {
    await dispatch(ActivityActions.invokeEbookGalleryView(open,pages));
}
export const handleRevokeEbookGalleryView = () => async (dispatch) => {
    await dispatch(ActivityActions.revokeEbookGalleryView());
}

export const handleInvokeAnswer = (open,pages,type) => async (dispatch) => {
    await dispatch(ActivityActions.invokeAnswer(open,pages,type));
}
export const handleRevokeAnswer = () => async (dispatch) => {
    await dispatch(ActivityActions.revokeAnswer());
}

export const handleInvokeStory = (open,pages,type) => async (dispatch) => {
    await dispatch(ActivityActions.invokeStory(open,pages,type));
}
export const handleRevokeStory = () => async (dispatch) => {
    await dispatch(ActivityActions.revokeStory());
}

export const handleInvokePDF = (open, pdf) => async (dispatch) => {
    await dispatch(ActivityActions.invokePDF(open, pdf));
}
export const handleRevokePDF = () => async (dispatch) => {
    await dispatch(ActivityActions.revokePDF());
    dispatch(updateUI({ openPopUpAtOnce: false }));
}

export const handleInvokeActivityStandards = (open, activities, standards, enabledStateCodes, bookData, units, pages, currentPage) => async (dispatch) => {
    await dispatch(ActivityActions.invokeActivityStandards(open, activities, standards, enabledStateCodes, bookData, units, pages, currentPage));
}
export const handleRevokeActivityStandards = () => async (dispatch) => {
    await dispatch(ActivityActions.revokeActivityStandards());
}